import { render, staticRenderFns } from "./ContentViewSettingsPublicRelated.vue?vue&type=template&id=e6ee7792&scoped=true&"
import script from "./ContentViewSettingsPublicRelated.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsPublicRelated.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsPublicRelated.vue?vue&type=style&index=0&id=e6ee7792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ee7792",
  null
  
)

export default component.exports